export enum UpsertModalType {
  Add = "Add",
  Edit = "Edit",
}
